var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75949 1.46999C8.42347 0.882724 7.57658 0.882727 7.24056 1.46999L0.671638 12.9505C0.337868 13.5338 0.759042 14.26 1.4311 14.26L14.569 14.26C15.241 14.26 15.6622 13.5338 15.3284 12.9505L8.75949 1.46999ZM7.98181 5.38116C8.32699 5.38116 8.60681 5.66099 8.60681 6.00616L8.60681 9.0296C8.60681 9.37478 8.32699 9.6546 7.98181 9.6546C7.63663 9.6546 7.35681 9.37478 7.35681 9.0296V6.00616C7.35681 5.66099 7.63663 5.38116 7.98181 5.38116ZM8 12.0132C8.41421 12.0132 8.75 11.6774 8.75 11.2632C8.75 10.8489 8.41421 10.5132 8 10.5132C7.58579 10.5132 7.25 10.8489 7.25 11.2632C7.25 11.6774 7.58579 12.0132 8 12.0132Z",
    fill: "#FF7A05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.3f634082fba46f07fded3ff8cd789407.svg";
export { ForwardRef as ReactComponent };